import { render } from "./ClienteEmDesenv.vue?vue&type=template&id=169968d0&scoped=true"
import script from "./ClienteEmDesenv.vue?vue&type=script&lang=js"
export * from "./ClienteEmDesenv.vue?vue&type=script&lang=js"

import "./ClienteEmDesenv.vue?vue&type=style&index=0&id=169968d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169968d0"]])

export default __exports__